export default __webpack_public_path__ + "static/media/Eichler.caf7d709.webp";